// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__3zQxr","additionalInfo":"AgreementModal_additionalInfo__3oZx1"};